const ClickOutside = {
  beforeMount(el, binding) {
      el.clickOutsideEvent = function(event) {
          // Check if the clicked element is neither the element
          // to which the directive is applied nor its child
          if (!(el === event.target || el.contains(event.target))) {
              // Invoke the provided method
              binding.value(event);
          }
      };
      document.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el) {
      // Remove the event listener when the bound element is unmounted
      document.removeEventListener('click', el.clickOutsideEvent);
  },
};

class PromoTimer extends HTMLElement {
  app; diff;
  static YEAR = 1000*60*60*24*365;
  static MONTH = 1000*60*60*24*30;
  static DAY = 1000*60*60*24;
  static HOUR = 1000*60*60;
  static MINUTE = 1000*60;
  static SECOND = 1000;

  connectedCallback() {
    this.date = parseInt(this.dataset.date)*PromoTimer.SECOND;
    this.diff = this.date - new Date().getTime();
    this.initApp();
  }

  initApp = () => {
    this.app = Vue.createApp({
      delimiters: ['${', '}'],
      data: () => {
        return {
          totalSeconds: this.diff,
          years: 0,
          months: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        }
      },
      mounted: () => {
        this.startTimer();
      }
    }).mount(this);
  }

  startTimer = () => {
    setInterval(() => {
      this.app.totalSeconds = this.date - new Date().getTime();
      this.app.years = Math.floor(this.app.totalSeconds / PromoTimer.YEAR);
      this.app.months = Math.floor(this.app.totalSeconds%PromoTimer.YEAR / PromoTimer.MONTH);
      this.app.days = Math.floor(this.app.totalSeconds%PromoTimer.MONTH / PromoTimer.DAY);
      this.app.hours = Math.floor(this.app.totalSeconds%PromoTimer.DAY / PromoTimer.HOUR);
      this.app.minutes = Math.floor(this.app.totalSeconds%PromoTimer.HOUR / PromoTimer.MINUTE);
      this.app.seconds = Math.floor(this.app.totalSeconds%PromoTimer.MINUTE / PromoTimer.SECOND);
    }, PromoTimer.SECOND);
  }
}
if (!window.customElements.get("promo-timer")) {
  window.customElements.define("promo-timer", PromoTimer);
}

class MainHeader extends HTMLElement {
  app;

  connectedCallback() {
    this.initApp();
  }

  initApp = () => {
    const component = this;
    this.app = Vue.createApp({
      delimiters: ['${', '}'],
      data: () => {
        return {
          transparent: true,
          scrollPosition: window.scrollY,
          menuOpen: '',
          cartCount: parseInt(component.dataset.cartCount),
          q: '',
          search: false,
          results: [],
          searching: false,
          searchUrl: `${window.Shopify.routes.root}search?type=product`
        }
      },
      methods: {
        handleScroll() {
          this.scrollPosition = window.scrollY;
          this.setTransparent();
        },
        handleHover() {
          this.transparent = false;
        },
        setTransparent() {
          this.transparent = this.scrollPosition < 100 && this.menuOpen === '' && !this.search;
        },
        openMenu(menu) {
          if(!this.search) {
            this.menuOpen = menu;
          }
        },
        closeMenu() {
          this.menuOpen = '';
          this.setTransparent();
        },
        formatMoney(value) {
          return Utils.money(value*100);
        },
        updateQuantity() {
          Utils.getCart({
            success: (response) => {
              this.cartCount = response.item_count;
            }
          });
        },
        opensSearch() {
          this.search = true;
          this.closeMenu();
          this.$nextTick(() => {
            this.$refs.searchInput.focus();
          });
        },
        closeSearch() {
          this.search = false;
          this.q = '';
          this.results = [];
        },
        searchQuery() {
          if(this.q.length > 2 && !this.searching) {
            this.searching = true;
            Utils.search({
              params: {
                q: this.q
              },
              success: (response) => {
                this.searchUrl = `${window.Shopify.routes.root}search?q=${this.q}&type=product`;
                this.results = response.resources.results.products;
              },
              finally: () => {
                this.searching = false;
              }
            });
          }
        }
      },
      directives: {
        clickOutside: ClickOutside
      },
      mounted() {
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener(Utils.E_CART_ADDED, this.updateQuantity);
        window.addEventListener(Utils.E_CART_UPDATED, this.updateQuantity);
      }
    }).mount(this);
  }
}
if (!window.customElements.get("main-header")) {
  window.customElements.define("main-header", MainHeader);
}

class AsideMenu extends HTMLElement {
  app;

  connectedCallback() {
    this.initApp();
  }

  initApp = () => {
    const component = this;
    this.app = Vue.createApp({
      delimiters: ['${', '}'],
      data: () => {
        return {
          menu: "",
          search: false,
          q: '',
          results: [],
          searching: false,
          searchUrl: `${window.Shopify.routes.root}search?type=product`
        }
      },
      methods: {
        formatMoney(value) {
          return Utils.money(value*100);
        },
        searchQuery() {
          if(this.q.length > 2 && !this.searching) {
            this.searching = true;
            Utils.search({
              params: {
                q: this.q
              },
              success: (response) => {
                this.searchUrl = `${window.Shopify.routes.root}search?q=${this.q}&type=product`;
                this.results = response.resources.results.products;
              },
              finally: () => {
                this.searching = false;
              }
            });
          }
        }
      },
      mounted() {
      }
    }).mount(this);
  }
}
if (!window.customElements.get("aside-menu")) {
  window.customElements.define("aside-menu", AsideMenu);
}
class MainProduct extends HTMLElement {
  data; swiper;

  connectedCallback() {
    this.data = JSON.parse(this.querySelector('script').innerText);
    this.swiper = this.querySelector('theme-swiper');
    this.querySelector('script').remove();
    this.initApp();
  }

  initApp = () => {
    const component = this;
    this.app = Vue.createApp({
      delimiters: ['${', '}'],
      data: () => {
        return {
          i: component.data,
          adding: false,
          quantity: 1,
          engraving: false,
          engravingFont: component.data.engraving ? component.data.engraving[0].name : '',
          engravingText: component.data.engravingText,
          customText: '',
          recipient: false
        }
      },
      methods: {
        updateQuantity(value) {
          const min = 1;
          const max = parseInt(this.i.quantities[this.i.variant.id]);
          const v = parseInt(value);
          this.quantity = v < min ? min : v > max ? max : v;
        },
        findVariant(optionIndex, value) {
          const options = [...this.i.variant.options];
          options[optionIndex] = value;
          const variants = this.i.product.variants.filter((variant) => {
            var isThat = true;
            options.forEach((option, i) => {
              isThat = variant.options[i].localeCompare(option) === 0 && isThat;
            });
            return isThat;
          });
          return variants[0];
        },
        changeVariant(index, value) {
          this.i.variant = this.findVariant(index, value);
          this.updateAvailability();
          if(this.i.variant.featured_image)
            component.swipeGallery(this.i.variant.featured_image.id);
          window.history.replaceState({}, '', `${location.pathname}?variant=${this.i.variant.id}`);
        },
        updateAvailability() {
          this.i.options.forEach((option, index) => {
            option.values.forEach((value, i) => {
              const variant = this.findVariant(index, value.name);
              this.i.options[index].values[i].available = variant.available;
            });
          });
        },
        isEngraving(texts) {
          const values = texts.toLowerCase().split(',');
          values.forEach((value) => {
            const v = value.trim();
            this.engraving = this.i.variant.options.filter((option) => option.toLowerCase() == v).length > 0;
            if(this.engraving) {
              return;
            }
          });
          return this.engraving;
        },
        formatMoney(value) {
          return Utils.money(value);
        },
        addToCart() {
          if(!this.adding && component.querySelector('theme-form').validate()) {
            this.adding = true;
            Utils.addTocart({
              form: component.querySelector('form'),
              finally: () => {
                this.adding = false;
              }
            });
          }
        },
        addFont() {
          const fontUrls = this.getFontUrls(this.engravingFont);
          fontUrls.forEach((fontUrl) => {
            const fontFace = new FontFace(this.engravingFont, `url(${fontUrl})`);
            fontFace.load().then(() => {
              document.fonts.add(fontFace);
              this.$forceUpdate();
            });
          });
        },
        getFontUrls(font) {
          return this.i.engraving.filter((f) => f.name === font)[0].fonts;
        },
        checkEngraving(max) {
          if(this.engravingText.length > max) {
            this.engravingText = this.engravingText.substring(0, max);
          }
        },
        setCustomText(symbol=null) {
          if(symbol.length) {
            this.customText += symbol;
          }
          const hiddenOptions = this.i.options.filter((option) => option.isHidden);
          const option = hiddenOptions[0];
          const maxValue = this.findFirstAndLastInteger(option?.values[option?.values.length-1]?.name)?.last || this.i.maxCustomText;

          this.customText = this.customText.replace(/[^a-zA-Z★❤]/g, '');
          const length = this.customText.length;
          if(length > maxValue) {
            this.customText = this.customText.substring(0, maxValue);
          }
          if(option){
            option.values.forEach((value, index) => {
              var min = index == 0 ? 0 : this.findFirstAndLastInteger(value.name).first;
              var max = this.findFirstAndLastInteger(value.name).last;
              if(length >= min && length <= max) {
                this.changeVariant(option.index, value.name);
              }
            });
          }
        },
        findFirstAndLastInteger(str) {
          if(str){
            const matches = str.match(/-?\d+/g);
            if (!matches) {
              return null;
            }
            const numbers = matches.map(Number);
            return {
              first: numbers[0],
              last: numbers[numbers.length - 1],
            };
          }
          return null;
        }
      },
      mounted() {
      }
    });
    this.app.mount(this);
  }

  swipeGallery = (imageId) => {


    this.swiper = document.getElementById('gall1');
    this.swiper.querySelectorAll('.swiper-slide').forEach((slide, index) => {
      const id = parseInt(slide.dataset.id);
      if(id == imageId) {
        this.swiper.slideTo(index, 500);
        //return;
      }
    });

    this.swiper1 = document.getElementById('gall2');
    this.swiper1.querySelectorAll('.swiper-slide').forEach((slide, index) => {
      const id = parseInt(slide.dataset.id);
      if(id == imageId) {
        this.swiper1.slideTo(index, 500);
        //return;
      }
    });






  }
}
if (!window.customElements.get("main-product")) {
  window.customElements.define("main-product", MainProduct);
}

class MainCart extends HTMLElement {
  data;

  connectedCallback() {
    this.data = JSON.parse(this.querySelector('script').innerText);
    this.data.items = this.data.cart.items.map((item) => {
      item.isgift = this.data.gift?.variant == item.variant_id;
      return item;
    });
    this.querySelector('script').remove();
    this.initApp();
  }

  initApp = () => {
    const component = this;

    this.app = Vue.createApp({
      delimiters: ['${', '}'],
      data: () => {
        return {
          i: component.data,
          updated: false
        }
      },
      methods: {
        updateQuantity(value, key) {
          const item = this.findItem(key);
          const min = 1;
          const max = parseInt(item.max);
          const v = parseInt(value);
          const old = item.quantity;
          if(max > 0)
            item.quantity = v < min ? min : v > max ? max : v;
          else
            item.quantity = v < min ? min : v;
          if(item.quantity != old) {
            this.updateCart();
          }
        },
        getCart() {
          component.openDrawer();
          Utils.getCart({
            success: (response) => {
              this.i.cart = response;
            }
          });
        },
        updateCart() {
          const lines = {
            updates: {}
          };
          this.i.cart.items.forEach((item) => {
            lines.updates[item.variant_id] = item.quantity;
          });
          axios({
            method: 'post',
            url: `${window.Shopify.routes.root}cart/update.js`,
            data: JSON.stringify(lines),
            headers: {
              'Content-Type': 'application/json',
            },
          }).then((response) => {
            this.i.cart = response.data;
            window.dispatchEvent(new CustomEvent(Utils.E_CART_UPDATED, { detail: this.i.cart }));
          });
        },
        formatMoney(value) {
          return Utils.money(value);
        },
        removeItem(key) {
          const item = this.findItem(key);
          item.quantity = 0;
          this.updateCart();
        },
        removeCarousel(c){
          c.items.forEach((item) => {
            item.quantity = 0;
          });
          c.carousel.quantity = 0;
          this.updateCart();
        },
        findItem(key){
          return this.i.cart.items.filter((item) => item.key === key)[0];
        }
      },
      computed: {
        isGift: {
          get() {
            return this.i.cart.attributes.Regalo == 'Si';
          },
          set(value) {
            this.i.cart.attributes.Regalo = value ? 'Si' : 'No';
          }
        },
        items: {
          get() {
            const c = {
              carousels: [],
              items: []
            };
            const carouselMap = {};
            this.i.cart.items.forEach(item => {
              const carouselId = item.properties.carousel;

              if (carouselId) {
                if (!carouselMap[carouselId]) {
                  carouselMap[carouselId] = { carousel: null, items: [] };
                }
                if (item.variant_id == carouselId) {
                  carouselMap[carouselId].carousel = item;
                } else {
                  carouselMap[carouselId].items.push(item);
                }
              } else {
                if(this.i.info[item.key]){
                  item.hasvariants = this.i.info[item.key].hasvariants;
                  item.max = this.i.info[item.key].max;
                }
                c.items.push(item);
              }
            });

            for (const carouselId in carouselMap) {
              if (carouselMap[carouselId].carousel) {
                c.carousels.push({
                  total: carouselMap[carouselId].items.reduce((acc, item) => acc + item.final_line_price, 0) + carouselMap[carouselId].carousel.final_line_price,
                  carousel: carouselMap[carouselId].carousel,
                  items: carouselMap[carouselId].items
                });
              }
            }
            return c;
          }
        }
      },
      mounted() {
        window.addEventListener(Utils.E_CART_ADDED, () => {
          this.getCart();
        });
        window.addEventListener(Utils.E_CART_UPDATED, () => {
          this.getCart();
        });
      }
    });
    this.app.mount(this);
  }

  openDrawer = () => {
    this.drawer = this.querySelector('.offcanvas');
    if(this.drawer) {
      const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(this.drawer);
      offcanvas.show();
    }
  }

  closeDrawer = () => {
    this.drawer = this.querySelector('.offcanvas');
    if(this.drawer) {
      const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(this.drawer);
      offcanvas.hide();
    }
  }
}
if (!window.customElements.get("main-cart")) {
  window.customElements.define("main-cart", MainCart);
}

class MainCarousel extends HTMLElement {
  data;

  connectedCallback() {
    this.data = JSON.parse(this.querySelector('script').innerText);
    this.querySelector('script').remove();
    this.initApp();
  }

  initApp = () => {
    const component = this;
    this.app = Vue.createApp({
      delimiters: ['${', '}'],
      data: () => {
        return {
          i: component.data,
          bracelet: null,
          search: '',
          results: this.data.letters,
          carousel: [],
          max: component.dataset.max,
          dragIndex: null,
          touchIndex: null,
          touchY: 0,
          small_i: 0,
          big_i: 0,
          cutoff: 0,
          sides: 1,
          side: 0
        }
      },
      methods: {
        chooseBracelet(bracelet) {
          if(bracelet.variant.available) {
            this.bracelet = bracelet;
            this.max = this.bracelet.variant.type == 'ring' || this.bracelet.variant.type == 'ring-center' ? 3 : this.max;
            this.carousel = [...Array(parseInt(this.max))];
            this.small_i = 0;
            this.big_i = this.bracelet.variant.type == 'ring' || this.bracelet.variant.type == 'ring-center' ? 0 : this.bracelet.variant.type == 'ring-left' ? 3 : 0;
            this.cutoff = this.bracelet.variant.type == 'ring' || this.bracelet.variant.type == 'ring-center' ? 0 : this.bracelet.variant.type == 'ring-left' ? 3 : 0;
            this.sides = this.bracelet.variant.type == 'ring' || this.bracelet.variant.type == 'ring-center' ? 1 : this.bracelet.variant.type == 'ring-left' ? 2 : 1;
            window.scrollTo({ top: 0 });
          }
        },
        changeVariant(product, variant) {
          if(variant.available)
            product.variant = variant;
        },
        formatMoney(value) {
          return Utils.money(value);
        },
        searchLetter() {
          this.results = this.i.letters.filter((letter) => {
            return letter.title.toLowerCase().includes(this.search.toLowerCase());
          });
        },
        addCarousel(variant) {
            const v = JSON.parse(JSON.stringify(variant));
            v.key = `${v.id}-${this.carousel.length}`;
            if( this.sides < 2 || this.side == 1 ){
              if( this.big_i >= parseInt(this.max)){
                return;
              }
              this.carousel[this.big_i] = v;
              this.big_i = this.big_i + 1;
            }
            else {
                if(this.small_i >= this.cutoff){
                  return;
                }
                this.carousel[this.small_i] = v;
                this.small_i = this.small_i + 1;
              }
            variant.quantity = this.carousel.filter((v) => v?.id === variant.id).length;
        },
        selectCarousel(index, tapeLetters) {
          console.log(this.carousel);
          index = tapeLetters && this.sides > 1 ? index + this.cutoff : index;
          this.carousel[index].selected = !this.carousel[index].selected;
        },
        removeCarousel(index, tapeLetters) {
            index = tapeLetters && this.sides > 1 ? index + this.cutoff : index;
            if( this.sides < 2 || tapeLetters ){
              this.carousel.splice(index, 1);
              this.carousel.push(undefined);
              this.big_i = this.big_i - 1;
            }
            else {
              this.carousel.splice(index, 1);
              this.carousel.splice(this.cutoff - 1, 0, undefined);
              this.small_i = this.small_i - 1;
            }
          this.carousel.filter((v, i) => v != undefined).forEach((v) => {v.selected = false});
        },
        swapSide(side){
          this.side = side;
        },
        addCart() {
          axios({
            method: 'post',
            url: `${window.Shopify.routes.root}cart/add.js`,
            data: JSON.stringify({
              items: this.variants
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          }).then((response) => {
            console.log(response);
            window.dispatchEvent(new CustomEvent(Utils.E_CART_ADDED, { detail: response.data }));
          }).catch((error) => {
            Utils.errorHanlder(error);
          });
        },
        reset() {
          //this.carousel = [];
          //this.bracelet = null;
          //this.results = this.i.letters;
          //this.search = '';
          //window.scrollTo({ top: 0 });
          window.location.reload();
        },
        empty(){
          this.chooseBracelet(this.bracelet);
        },
        dragStart(index) {
          this.dragIndex = index;
        },
        dragEnter(index) {
          if (index !== this.dragIndex && this.carousel[this.dragIndex] != undefined && this.carousel[index] != undefined) {
            const draggedItem = this.carousel.splice(this.dragIndex, 1)[0];
            this.carousel.splice(index, 0, draggedItem);
            this.dragIndex = index;
          }
        },
        drop() {
          this.dragIndex = null;
        },
        touchStart(index, event) {
          if(this.carouse[index] != undefined)
            this.touchIndex = index;
            this.touchY = event.touches[0].clientY;
        },
        touchMove(event) {
          const currentY = event.touches[0].clientY;
          const direction = currentY > this.touchY ? 1 : -1;
          const targetIndex = this.touchIndex + direction;

          if (targetIndex >= 0 && targetIndex < this.carousel.length && this.carousel[targetIndex] != undefined) {
            const draggedItem = this.carousel.splice(this.touchIndex, 1)[0];
            this.carousel.splice(targetIndex, 0, draggedItem);
            this.touchIndex = targetIndex;
            this.touchY = currentY;
          }
        },
        touchEnd() {
          this.touchIndex = null;
        }
      },
      computed: {
        totalPrice: {
          get() {
            var price = this.bracelet ? this.bracelet.variant.price : 0;
            return this.carousel.reduce((acc, variant) => {
              const v_price = variant == undefined ? 0 : variant.price;
              return acc + v_price;
            }, price);
          }
        },
        variants: {
          get() {
            const variants = {};
            variants[this.bracelet.variant.id] = 1;
            this.carousel.forEach((variant) => {
              if(variant != undefined)
                variants[variant.id] = (variants[variant.id] || 0) + 1;
            });
            return Object.keys(variants).map(key => {
              return {
                id: key,
                quantity: variants[key],
                properties: {
                  carousel: this.bracelet.variant.id,
                  tape: this.carousel.filter((v, i) => { return i >= this.cutoff && v?.id == key}).length,
                  ring: this.carousel.filter((v, i) => { return i < this.cutoff && v?.id == key}).length,
                }
              }
            });
          }
        },
        ringLetters: {
          get() {
            return this.carousel.filter((v, i) => { return (i < this.cutoff || this.cutoff == 0)});
          }
        },
        tapeLetters: {
          get() {
            return Array.from(this.carousel).filter((v, i) => { return i >= this.cutoff});
          }
        }
      }
    });
    this.app.mount(this);
  }
}
if (!window.customElements.get("main-carousel")) {
  window.customElements.define("main-carousel", MainCarousel);
}
